// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ec-tooltip-container .ec-tooltip {
    max-width: 300px;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    background-color: #7351fd;
    color: #fff;
    border-radius: 6px;
    padding: 12px;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/pages/Products/components/common/Tooltip/style.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB","sourcesContent":[".ec-tooltip-container .ec-tooltip {\n    max-width: 300px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 400;\n    background-color: #7351fd;\n    color: #fff;\n    border-radius: 6px;\n    padding: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
